import { render, staticRenderFns } from "./cut-popup.vue?vue&type=template&id=bd51a766&scoped=true&"
import script from "./cut-popup.vue?vue&type=script&lang=ts&"
export * from "./cut-popup.vue?vue&type=script&lang=ts&"
import style0 from "./cut-popup.vue?vue&type=style&index=0&id=bd51a766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd51a766",
  null
  
)

export default component.exports